define(function (require, exports, module) {
    'use strict';

    var UploadReason = require('./UploadReason');

    /**
     * @constructor
     * @extends {UploadReason}
     * @param {Error} stack
     * @param {string} source
     */
    function UploadCancel(stack, source) {
        UploadReason.apply(this, arguments);
    }

    UploadCancel.prototype = Object.assign(Object.create(UploadReason.prototype), {
        constructor: UploadCancel,
        className: 'UploadCancel',
        radarName: 'cancel_{SOURCE}_single',
        message: 'Отменено',
    });

    module.exports = UploadCancel;
});
